import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollWindowToTop = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
};

/** Scroll to top on client-side route changes (React Router does not do this by default). */
const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    useEffect(() => {
        scrollWindowToTop();
        // Mobile Safari can restore scroll after paint — run again on next frame.
        const frame = requestAnimationFrame(scrollWindowToTop);
        return () => cancelAnimationFrame(frame);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
